<template>
  <router-view />
</template>

<script>
/**
 * Implement landing page for consolidation of splits.
 */
export default {
  name: 'LandingPage',
};
</script>
